export default [
    "BAR 最优门市价",
    "Package & Promotion 包价和促销",
    "E-commerce 电子商务价",
    "Total Retail 零售散客合计",
    "Traditional Wholesale 传统旅游批发商",
    "Online Wholesale 在线旅游批发商",
    "Total Wholesale 旅游批发商合计",
    "TMC 商旅管理公司价",
    "Local Negotiate 本地协议价",
    "National Key Account 全国性协议价",
    "Total Corporate 公司散客合计",
    "Government/Diplomat 政府价",
    "Qualified Discount 特殊折扣价",
    "Award&Redemption 积分奖励和兑换",
    "Total Discount&Award 折扣与奖励合计",
    "Total Transient 散客合计",
    "MICE Group 会议团",
    "Government Group 政府团",
    "Total Business Group 商务团队合计",
    "Group Tour Series 系列旅游团",
    "Group Ad Hoc 一次性旅游团",
    "Group Others 其他团队",
    "Total Tour Group 旅游团队合计",
    "Total Group 团队合计",
    "Long Stay 长住",
    "Air Crew 机组",
    "Flight Layover 误机客",
    "Total Contracts 合同价合计",
    "Barter ",
    "House Use 自用房",
    "Comp Room 免费房",
    "Other Revenue 其他收入",
    "Service Charge 服务费",
    "Total Others 其它合计",
    "总计 （不含免房）",
    "Net Available Rooms 实际可卖房量",
    "Unsold Rooms 未售出房量",
    "出租率/平均房价/每房收益"
].map((name, i) => ({
    name,
    key: name,
    sort: i,
    jan_rn: 0,
    jan_adr: 0,
    jan_rev: 0,
    feb_rn: 0,
    feb_adr: 0,
    feb_rev: 0,
    mar_rn: 0,
    mar_adr: 0,
    mar_rev: 0,
    apr_rn: 0,
    apr_adr: 0,
    apr_rev: 0,
    may_rn: 0,
    may_adr: 0,
    may_rev: 0,
    jun_rn: 0,
    jun_adr: 0,
    jun_rev: 0,
    jul_rn: 0,
    jul_adr: 0,
    jul_rev: 0,
    aug_rn: 0,
    aug_adr: 0,
    aug_rev: 0,
    sep_rn: 0,
    sep_adr: 0,
    sep_rev: 0,
    oct_rn: 0,
    oct_adr: 0,
    oct_rev: 0,
    nov_rn: 0,
    nov_adr: 0,
    nov_rev: 0,
    dec_rn: 0,
    dec_adr: 0,
    dec_rev: 0,
    full_rn: 0,
    full_adr: 0,
    full_rev: 0,
})) 


// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/history/data.js